import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/affordable-self-storage-services.jpg'),
    alt: 'affordable self storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'affordable self storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Self Storage</span><span>Services Near You</span>',
  description:
    'Secure, reliable, and cost-effective storage solutions tailored to meet your needs. Enjoy budget-friendly storage options without compromising quality or security.',
  image: {
    url: '/images/v2/pages/landing-pages/affordable-self-storage-services/hero-image.jpg',
    alt: 'Affordable Self Storage Services Near You'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Self-Storage Services' }
}

export const ourProcessSectionContent = {
  title: 'How Our Affordable Self-Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/affordable-self-storage-services/how-our-affordable-self-storage-services-work.png',
    alt: 'How Our Affordable Self-Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Reservations',
      description: 'Reserve your storage unit in just a few clicks through our seamless online booking system.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-self-storage-services/easy-online-reservations.png',
        alt: 'Easy Online Reservations'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description: 'All storage units are equipped with 24/7 surveillance and climate control for added protection.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-self-storage-services/secure-storage-facilities.png',
        alt: 'Secure Storage Facilities'
      }
    },
    {
      id: 3,
      title: 'Flexible Access Options',
      description: 'Access your stored items at your convenience with our flexible access hours.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-self-storage-services/flexible-access-options.png',
        alt: 'Flexible Access Options'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast Self Storage Services Available',
  description:
    'Our services are designed to provide high-quality storage solutions at prices that fit your budget, ensuring your belongings are safe and accessible when you need them.',
  image: {
    src: '/images/v2/pages/landing-pages/affordable-self-storage-services/fast-self-storage-services-available.jpg',
    alt: 'Fast Self Storage Services Available'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Services',

  cards: [
    {
      id: 1,
      title: 'Budget-Friendly Solutions',
      description: 'Affordable storage options for individuals, families, and businesses.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Budget-Friendly Solutions'
      }
    },
    {
      id: 2,
      title: 'Enhanced Security',
      description: 'Your items are protected in monitored, climate-controlled storage facilities.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Enhanced Security'
      }
    },
    {
      id: 3,
      title: 'Convenient Locations',
      description: 'Easily accessible storage facilities located near you.',
      image: {
        src: '/images/v2/pages/common/convenient-locations.png',
        alt: 'Convenient Locations'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners and Renters',
          description:
            'Declutter your living space with affordable storage for furniture, seasonal items, or valuables.'
        },
        {
          id: 2,
          title: 'Small Business Owners',
          description: 'Store inventory, documents, or equipment at a fraction of the cost of traditional storage.'
        },
        {
          id: 3,
          title: 'Students',
          description: 'Save money with affordable storage options during breaks or when transitioning between dorms.'
        },
        {
          id: 4,
          title: 'Frequent Travelers',
          description: 'Securely store luggage or personal belongings during extended trips.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/affordable-self-storage-services/who-should-use-our-services.jpg',
        alt: 'Who Should Use Our Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Storage Services',

  cards: [
    {
      id: 1,
      title: 'Personal Storage Options',
      description: 'Keep your belongings safe and organized with secure, budget-friendly storage units.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Personal Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Seasonal Storage Services',
      description: 'Store seasonal items like holiday decorations or sports equipment cost-effectively.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Seasonal Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage Solutions',
      description: 'Affordable storage for inventory, files, or office equipment to support your business needs.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Short-Term and Long-Term Storage',
      description: 'Flexible storage plans that cater to your specific timeline and budget.',
      image: {
        src: '/images/v2/pages/common/short-term-and-long-term-storage.png',
        alt: 'Short-Term and Long-Term Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Affordable Self-Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/affordable-self-storage-services/why-choose-us-for-affordable-self-storage-services.jpg',
    alt: 'Why Choose Us for Affordable Self-Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Transparent Pricing',
      description: 'No hidden fees—just clear, upfront pricing you can count on.'
    },
    {
      id: 2,
      title: 'Customer-Focused Service',
      description: 'Our team is dedicated to providing exceptional support and guidance.'
    },
    {
      id: 3,
      title: 'Secure and Monitored Facilities',
      description: '24/7 surveillance and restricted access ensure the safety of your belongings.'
    },
    {
      id: 4,
      title: 'Wide Range of Unit Sizes',
      description: 'Find the perfect unit size to match your storage needs, from small to large.'
    },
    {
      id: 5,
      title: 'Flexible Storage Plans',
      description: 'Choose from a range of short-term and long-term storage options.'
    },
    {
      id: 6,
      title: 'Accessible Locations',
      description: 'Conveniently located storage facilities for easy access.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Affordable Self Storage Services Near You Fast',
  description:
    'Affordable self-storage services near you. Fast, secure, and convenient solutions for storing your personal items safely.',
  image: {
    src: '/images/v2/pages/landing-pages/affordable-self-storage-services/affordable-self-storage-services-near-you-fast.png',
    alt: 'Affordable Self Storage Services Near You Fast'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Saving on Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage and Shipping Partners',
  description: 'We collaborate with leading providers to ensure reliable and cost-effective storage services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides dependable logistics solutions to manage and transport your stored items efficiently.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL ensures secure and efficient storage and shipping solutions for customers worldwide.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers trusted storage and shipping solutions with global expertise and reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
